import * as React from 'react';
import FormRow from 'Components/FormRow';
import FormSection from 'Components/FormSection';
import FormSectionBar from 'Components/FormSectionBar';
import { Item } from 'Components/Grid';
import InputHandler from 'Components/InputHandler';
import { historyValue } from '../../../../config/theme/componentTheme';
import { withFormContext } from 'Containers/FormContextHandler';
import type { IFormContext } from 'Containers/FormContextHandler';
import { formatRowData, getLastSeizureDate } from '../../utils';
import type { TSeizureDocumentType } from '../../utils';
import { calculateIntervalYMD, isPartialDate, nowPartialDate } from 'neuro-utils';

const DEFAULT_DOCUMENTS: IOwnProps['documents'] = [];

const NewSeizureFreePeriod = ({
  fm,
  documents = DEFAULT_DOCUMENTS,
  formData,
  editing,
}: IOwnProps): React.JSX.Element | null => {
  // fetch latest confirmed seizure date
  const lastSeizureDate = getLastSeizureDate(documents);
  const startDate = isPartialDate(formData.document.startDate) ? formData.document.startDate : lastSeizureDate;

  const prefix = 'seizure.'; // for localization

  const noData: React.ReactNode = fm('general.noData');
  const endDate = formData.document.endDate ?? nowPartialDate();
  const diff = startDate && calculateIntervalYMD(startDate, endDate);

  return (
    <>
      <FormSectionBar header={prefix + 'newSeizureFreePeriod'} />
      <FormSection>
        <FormRow title={prefix + 'startDate'}>
          <InputHandler
            type="PartialDate"
            name="startDate"
            formData={formData}
            editing={!!editing}
            dateDefault={lastSeizureDate ?? undefined}
            isNotCancellable={true}
          />
        </FormRow>
        <FormRow title={prefix + 'endDate'}>
          <InputHandler type="PartialDate" name="endDate" formData={formData} editing={!!editing} />
        </FormRow>
        <FormRow title={prefix + 'seizureFreePeriodLength'}>
          {lastSeizureDate ? (
            <Item style={historyValue}>{formatRowData('seizureFreePeriodLength', diff)}</Item>
          ) : (
            <>{noData}</>
          )}
        </FormRow>
        <FormRow title={prefix + 'seizureFreePeriodDetails'}>
          <InputHandler
            type="TextArea"
            name="seizureFreePeriodDetails"
            formData={formData}
            editing={!!editing}
            placeholder={prefix + 'detailsPlaceholder'}
          />
        </FormRow>
      </FormSection>
    </>
  );
};

type IOwnProps = IFormContext<IDocumentWithTypeV2<'seizureFreePeriod'>, IDocumentWithTypeV2<TSeizureDocumentType>>;

export default withFormContext(NewSeizureFreePeriod);
